module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_primaerlogo_pos.af4e1c8d.png";